import { z } from 'zod';
import { CharacterSchema } from './characterEntity';
import { CharacterRuntimeStateSchema } from './characterRuntime';

// ============================================
// 角色注册表（全局角色容器）
// ============================================

export const CharacterRegistryStateSchema = z.object({
  registry: z.record(z.string(), CharacterSchema).default({}),
  runtimeStates: z.record(z.string(), CharacterRuntimeStateSchema).default({}),
});

export type CharacterRegistryState = z.infer<typeof CharacterRegistryStateSchema>;
